import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Outlet, useNavigate } from "react-router";
import { useCheckUser } from "@/api/user/check-user";
import useGlobalLoading from "@/store/global-loading";
import FullscreenLoading from "../fullscreen-loading";
import { useEffect } from "react";

const OnboardingLayout = () => {
    const { isAuthenticated, isLoading } = useKindeAuth();
    const { isLoading: checkUserLoading } = useCheckUser();
    const { setIsLoading } = useGlobalLoading();
    // const { isStep3Complete } = useOnboardingData();

    // Show loading screen if authentication or user check is in progress
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoading || checkUserLoading) {
            setIsLoading(true);
        }

        if (!isAuthenticated) {
            navigate("/auth/sign-in", { replace: true });
        }
    }, [isLoading, checkUserLoading, setIsLoading, isAuthenticated, navigate]);

    // Redirect to login if not authenticated

    // Render the protected route content
    // if (
    //     !checkUserLoading &&
    //     userData?.meta?.code === 200 &&
    //     userData?.meta?.message === "Store and User found" &&
    //     userData?.data?.user?.is_paid &&
    //     isStep3Complete
    // ) {
    //     return <Navigate to="/app/dashboard" replace />;
    // }
    return (
        <>
            <div className="p-4 border-b-2 flex items-center justify-center">
                <img src="/assets/images/logo/shoe-ai-logo.png" alt="Shoe Einstein Logo" />
            </div>

            <Outlet />
            <div className="border-t fixed bottom-0 w-full flex items-center justify-center gap-1 py-1 bg-white">
                <small className="text-center block">Powered by GISL</small>
                <img src="/assets/images/logo/gisl.webp" alt="Shoe Einstein Logo" className="size-4" />
            </div>
            <FullscreenLoading />
        </>
    );
};

export default OnboardingLayout;
